export default __webpack_public_path__ + "static/media/Collars for Kings logo.4eb1944a.png";